export const dateFromId = id => new Date(Number(id.split("-", 1))).toLocaleDateString();